<app-navbar *ngIf="getAuthStatus()"></app-navbar>
<router-outlet></router-outlet>
<app-spinner></app-spinner>